import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('form',[_c(VCol,{staticClass:"mx-auto",attrs:{"cols":"6"}},[_c('locale-select',{on:{"change":_vm.fireLocaleChange}})],1),_c('form-wrapper',{attrs:{"validator":_vm.$v.form}},[_c(VRow,[_vm._l((_vm.getFieldsKeys),function(fieldName){return [_c(VCol,{key:fieldName,attrs:{"cols":"12","md":"6"}},[_c('Editor',{attrs:{"language":_vm.locale,"form":_vm.form,"fieldName":fieldName}})],1)]})],2)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }